export const ROSE = "#e72461";
export const ROSE_OLD = "#e72385";
export const ORANGE = "#e94c31";
export const VERT = "#298b94";
export const BLEU = "#241c97";
export const VIOLET = "#bc1e69";